import { render } from "./SubscribePopup.vue?vue&type=template&id=81bba5e4&scoped=true"
import script from "./SubscribePopup.vue?vue&type=script&lang=js"
export * from "./SubscribePopup.vue?vue&type=script&lang=js"

import "./SubscribePopup.vue?vue&type=style&index=0&id=81bba5e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81bba5e4"]])

export default __exports__